// The line editor's note shortcuts (UC-3.R8, #915): the words this till put
// in notes on an item, most used first, as its order store counts them. Any
// refusal or no answer, such as a store before native level 15, is no
// shortcut at all: the note field works as it always did.

import { store } from '../api/client';

export async function noteShortcuts(itemId: string): Promise<string[]> {
	try {
		const { data } = await store.GET('/store/items/{itemId}/note-shortcuts', {
			params: { path: { itemId } },
		});
		return data?.shortcuts.map((s) => s.words) ?? [];
	} catch {
		return [];
	}
}
